import React, { useEffect, useState } from "react";

/**
 * A simple error message component that displays an after placebet error
 * For tmporary time Bottom below Stake input.
 *
 * Exmple usage:
 * showError("An error occurred while placing your bet.");
 *
 * use cases:
 * - Display when odds changes and Accept odds changes is not checked
 * - Display when selectionLimit exceeded
 */

interface ErrorMessageProps {
  message: string | null;
  onDismiss: () => void;
  autoHideDuration?: number;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  onDismiss,
  autoHideDuration = 5000,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);

      // Auto-dismiss after specified duration
      const timer = setTimeout(() => {
        setIsVisible(false);
        // Give time for fade-out animation before calling onDismiss
        setTimeout(onDismiss, 300);
      }, autoHideDuration);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [message, autoHideDuration, onDismiss]);

  if (!message) return null;

  return (
    <div
      className={`transition-opacity duration-300 text-danger px-4 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

export default ErrorMessage;
